import {notification as staticNotification} from 'antd'
import type {NotificationInstance} from 'antd/es/notification/interface'

export const withAsyncErrorToast = async <T>(
  key: string,
  fn: () => Promise<T>,
  description?: string,
  notifyApi?: NotificationInstance
): Promise<T> => {
  const api = notifyApi || staticNotification
  api.destroy(key)
  try {
    return await fn()
  } catch (error: any) {
    api.error({
      key,
      message: `${key} failed`,
      description: error?.message || description || 'Something went wrong. Please try again.',
      duration: 6,
    })
    throw error
  }
}
